import React from 'react'
import Button from '../components/button/Button'


interface ISuretyModel {
    type?: "Delete" | "Block",
    isLoading?: boolean,
    onClick: () => void,
    toggleModel: () => void
}

const SuretyModel = ({ type = "Delete", isLoading, onClick, toggleModel }: ISuretyModel) => {
    return (
        <div className='w-full h-full fixed top-0 bg-black/50 backdrop-blur-sm left-0 z-50 flex items-center justify-center px-4'>
            <div className='p-7 rounded-2xl bg-white shadow-pop w-full max-w-[460px] fade-up'>
                <div className="flex items-start gap-4">
                    <div className="h-11 w-11 rounded-full bg-red-50 flex items-center justify-center shrink-0">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                            <line x1="12" y1="9" x2="12" y2="13"/>
                            <line x1="12" y1="17" x2="12.01" y2="17"/>
                        </svg>
                    </div>
                    <div>
                        <h2 className="font-display text-lg font-semibold tracking-tight text-lightBlack">Are you sure?</h2>
                        <p className="text-sm text-gray-500 mt-1">This action will {type.toLowerCase()} the item permanently.</p>
                    </div>
                </div>

                <div className='mt-7 flex items-center justify-end gap-3'>
                    <div className="w-auto">
                        <Button variant="secondary" className='!w-auto !px-5' onClick={toggleModel} disabled={isLoading}>Cancel</Button>
                    </div>
                    <div className="w-auto">
                        <Button className='!w-auto !px-5 !bg-red-500 hover:!bg-red-600' onClick={onClick} isLoading={isLoading} disabled={isLoading}>{type}</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuretyModel
